<template>
    <section>
        <AppBackground :title="title" />
        <v-container>
            <v-row>
                <v-col class="list-container">
                    <li
                        v-for="(message, index) in messages"
                        :key="index"
                    >
                        <h3 class="user-name">{{ message.name }}さん</h3>
                        <br>{{ message.comment }}
                        <v-divider></v-divider>
                    </li>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>

import AppBackground from './AppBackgroundHolder.vue'
import messageList from '../common/messageList'

export default {
    name: 'MessageList',
    components: {
        AppBackground,
    },
    data() {
        return {
            title: 'みんなのコメント',
            messages: messageList.messages,
        }
    }
}
</script>

<style lang="scss" scoped>
.list-container {
    margin-bottom: 100px;
}
li {
    list-style: none;
    padding: 15px;
}
.user-name {
  display: inline;
  padding-right: 20px;
}
</style>
